"use strict";
//@ts-nocheck
/**
 * Handle print link
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
Object.defineProperty(exports, "__esModule", { value: true });
const _main_1 = require("./_main");
_main_1.txGs1Base.print = {
    initialize: function () {
        'use strict';
        $('#print_link').on('click.txGs1Base', function (e) {
            e.preventDefault();
            window.print();
        });
        $('#sp_print_link').on('click.txGs1Base', function (e) {
            e.preventDefault();
            window.print();
        });
    }
};
exports.default = {};
